<template>
  <v-card class="recruit-banner">
    <v-responsive
      width="960"
      class="mx-auto"
      v-if="user"
      style="overflow: initial;"
      :class="responseheight"
    >
      <v-container class="inner-wrap pl-7 pr-7 pl-md-0 pr-md-0 d-flex">
        <v-avatar
          class="img-wrap pb-0 pt-0"
          size="100"
          v-if="user.ynImage === 'Y'"
        >
          <v-icon v-if="!base64" class="material-icons-outlined">person</v-icon>
          <img v-if="base64" :src="base64" alt="profile image" style="" />
        </v-avatar>
        <div class="info-wrap" :class="noimageclass">
          <p class="name mb-3">{{ user.name }}</p>
          <p class="email mb-1">{{ user.email }}</p>
          <p class="contact mb-1">{{ user.phone }}</p>
          <div class="btn-wrap d-flex">
            <!-- 기본정보 변경 -->
            <PopChangeBasicInfo
              :user="user"
              @reset="setting"
              :isReadonly="isReadonly"
            ></PopChangeBasicInfo>
            <!-- 사진등록 -->
            <i-btn
              v-if="!isReadonly && user.ynImage === 'Y'"
              elevation="0"
              color="white"
              class="ml-2"
              outlined
              @click="upload"
              ><v-icon left class="material-icons-outlined">
                photo_camera </v-icon
              >{{ $t('사진등록') }}</i-btn
            >
            <CVProfileImgUpload
              ref="imageFile"
              v-if="user.ynImage === 'Y'"
              :existingFileId="user.image + ''"
              @upload="uploadImage"
            ></CVProfileImgUpload>
          </div>
        </div>
      </v-container>
    </v-responsive>
  </v-card>
</template>
<script>
import { getAuthJson, postAuthJson } from '@/api/network';
import { formatPhoneNumber } from '@/utils/filters';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';
import PopChangeBasicInfo from '@/views/PopChangeBasicInfo.vue';
import CVProfileImgUpload from '@/components/items/resume/CVProfileImgUpload.vue';

export default {
  mixins: [DialogMixin, LoadingMixin],
  props: {
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  mounted() {
    this.setting();
  },
  data: () => ({
    user: null,
    base64: null,
  }),
  components: {
    PopChangeBasicInfo,
    CVProfileImgUpload,
  },
  computed: {
    noimageclass: function() {
      return {
        'pl-7': this.user.ynImage != 'Y',
      };
    },
    responseheight: function() {
      return {
        h100: this.isReadonly,
        h138: !this.isReadonly,
      };
    },
  },
  methods: {
    setting: function() {
      const p = {
        annoId: this.$route.params.annoId,
      };
      getAuthJson('api/v1/' + this.$route.params.tenantKey + '/user', p)
        .then(res => {
          if (res.status === 200) {
            this.user = res.data;
            this.user.phone = formatPhoneNumber(this.user.phone);

            if (!this.user.image) {
              this.user.image = 0;
            } else {
              this.imagecall(this.user.image);
            }
          } else {
            console.log('USER DATA GET ERROR');
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    upload: function() {
      this.$refs.imageFile.open();
    },
    uploadImage: function(fileKey) {
      this.user.image = fileKey;
      this.save();
    },
    save: function() {
      const p = {
        annoId: this.$route.params.annoId,
        fileId: this.user.image,
      };
      postAuthJson('api/v1/' + this.$route.params.tenantKey + '/user/image', p)
        .then(res => {
          if (res.status !== 200) {
            console.log('IMAGE DATA SAVE ERROR');
          } else {
            this.imagecall(this.user.image);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imagecall: function(fileKey) {
      const p = {
        annoId: this.$route.params.annoId,
      };
      getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/cv/file/image/' + fileKey,
        p,
      )
        .then(res => {
          if (res.status === 200) {
            this.base64 = res.data;
          } else {
            console.log('IMAGE DATA GET ERROR');
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imageValid: function() {
      return (
        this.user.ynImage == 'N' ||
        (this.user.ynImage == 'Y' && this.user.image && this.user.image != 0)
      );
    },
  },
};
</script>

<style>
.recruit-banner.v-card {
  background-color: #0065bd;
}
.recruit-banner .inner-wrap {
  padding: 40px 0px 42px;
}
.recruit-banner .inner-wrap::after {
  content: '';
  display: table;
  width: 100%;
  clear: both;
}
.recruit-banner .inner-wrap .img-wrap {
  /* float: left; */
  margin-right: 30px;
  background-color: #004a8b;
  border-radius: 50%;
}
.recruit-banner .inner-wrap .img-wrap img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.recruit-banner .inner-wrap .img-wrap i.mdi {
  font-size: 40px;
  color: #0065bd;
  line-height: 100px;
}
/* .recruit-banner .inner-wrap .img-wrap img {
  height: auto;
} */
.recruit-banner .inner-wrap .info-wrap {
  float: left;
}
.recruit-banner .inner-wrap .name {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: -0.48px;
  color: #ffffff;
}
.recruit-banner .inner-wrap .email,
.recruit-banner .inner-wrap .contact {
  font-size: 16px;
  letter-spacing: -0.32px;
  text-align: left;
  color: #ffffff;
}

/* 2021.11.08 김대식 수정작업 */
.recruit-banner {
  padding: 40px 0 !important;
}

.recruit-banner .v-responsive__content {
  height: 100px !important;
}

.recruit-banner .inner-wrap {
  padding: 0px !important;
}

.recruit-banner .v-responsive.h100 {
  height: 100px !important;
}

.recruit-banner .v-responsive.h138 {
  height: 138px !important;
}

/* mobile 버전 배너 */
@media all and (max-width: 425px) {
  .recruit-banner .inner-wrap .img-wrap {
    margin-right: 15px;
  }

  .recruit-banner .inner-wrap .name {
    margin-bottom: 4px !important;
    font-size: 20px;
  }
  .recruit-banner .inner-wrap .email,
  .recruit-banner .inner-wrap .contact {
    font-size: 14px;
  }

  .recruit-banner .btn-wrap button {
    height: 30px !important;
    font-size: 12px;
    padding: 0px 12px;
  }
}
</style>
